import { MDBCol } from "mdb-react-ui-kit";
import { FC, useEffect, useState } from "react";
import DetailFixedBarMobile from "@/components/detail/DetailFixedBarMobile";
import useSticky from "@/hooks/useSticky";
import ModalCartContainer from "@/components/detail/addToCart/modal/ModalCartContainer";
import { TourReadableTO } from "@/models/detail";
import styles from "@/styles/detail/DetailBooking.module.scss";
import { useStore } from "@/store/index";
import {
    EDetailSection,
    ETourLanguage,
    ETypePackage,
} from "@/models/common/enums";
import DetailBookingConfigurator from "./DetailBookingSidebar/DetailBookingConfigurator";
import { RequestAQuoteForm } from "./RequestAQuoteForm";

const PackageDetailBookingMobile: FC<{
    packageDetail: TourReadableTO;
    isPremium: boolean;
    isOnScreen: boolean;
    price: number;
    // setPrice: Dispatch<SetStateAction<number>>;
    setIsPremium: (el: boolean) => void;
    // setIsPromo: (el: boolean) => void;
    offset: number;
    days: string;
    typePackage: ETypePackage;
    pricePremium: number;
    priceQuality: number;
    packagePremium: TourReadableTO;
    packageQuality: TourReadableTO;
    languages: ETourLanguage[];
    isRequestAQuote?: boolean;
}> = ({
    packageDetail,
    isPremium,
    isOnScreen,
    price,
    // setPrice,
    setIsPremium,
    offset,
    // setIsPromo,
    days,
    typePackage,
    pricePremium,
    priceQuality,
    packagePremium,
    packageQuality,
    languages,
    isRequestAQuote,
}) => {
    const { sticky, stickyRef, setOffset } = useSticky(1155);
    const [show, setShow] = useState(false);

    const currentSection = useStore(state => state.packageState.currentSection);

    const [displayBottomMenu, setDisplayBottomMenu] = useState(false);

    useEffect(() => {
        if (isOnScreen) {
            setOffset(offset);
        }
    }, [isOnScreen, offset]);

    useEffect(() => {
        if (currentSection === EDetailSection.GENERAL) {
            setDisplayBottomMenu(false);
        } else if (
            (currentSection === EDetailSection.ITINERARY ||
                currentSection === EDetailSection.ACCOMMODATION ||
                currentSection === EDetailSection.HIW) &&
            !displayBottomMenu
        ) {
            setDisplayBottomMenu(true);
        }
    }, [currentSection]);

    return (
        <>
            <MDBCol
                size={12}
                lg={4}
                ref={stickyRef}
                className={`p-0 ps-lg-4 ${styles.addToCartContainer} ${
                    sticky && styles.isStickyBottom
                } ${sticky ? "d-inline" : "d-none"}`}
            >
                <DetailFixedBarMobile
                    isPremium={isPremium}
                    onClick={() => setShow(true)}
                    price={price}
                    packageDetail={packageDetail}
                    days={days}
                    isRequestAQuote={isRequestAQuote}
                />
            </MDBCol>
            <ModalCartContainer setShow={setShow} show={show}>
                <MDBCol
                    size={12}
                    lg={4}
                    className={`p-0 ps-lg-4 ${styles.addToCartContainer}`}
                >
                    <DetailFixedBarMobile
                        isPremium={isPremium}
                        onClick={() => setShow(true)}
                        price={price}
                        packageDetail={packageDetail}
                        days={days}
                        isRequestAQuote={isRequestAQuote}
                    />
                </MDBCol>
                <MDBCol size={12} className={`${styles.addToCartContainer}`}>
                    {/* <PackageDetailAddToCart
                        isPremium={isPremium}
                        setIsPremium={setIsPremium}
                        setIsPromo={setIsPromo}
                        price={price}
                        setPrice={setPrice}
                        whatIsIncluded={packageDetail.whatIsIncluded}
                        associatedToursIds={packageDetail.associatedTours}
                        days={days}
                        tourId={packageDetail.tourId}
                        slots={packageDetail.slots}
                        typePackage={typePackage}
                    /> */}
                    {isRequestAQuote ? (
                        <RequestAQuoteForm
                            id={packageDetail.tourId}
                            title={packageDetail.tourTitle}
                            activities={
                                packageDetail.requestAQuoteActivities ?? []
                            }
                            fromSmallDevices
                        />
                    ) : (
                        <DetailBookingConfigurator
                            tourId={packageDetail.tourId}
                            isPremium={isPremium}
                            setIsPremium={setIsPremium}
                            slots={packageDetail.slots}
                            slotsPremium={packagePremium.slots}
                            slotsQuality={packageQuality.slots}
                            days={days}
                            typePackage={typePackage}
                            pricePremium={pricePremium}
                            priceQuality={priceQuality}
                            languages={languages}
                        />
                    )}
                </MDBCol>
            </ModalCartContainer>
        </>
    );
};

export default PackageDetailBookingMobile;
